<template>
  <div class="avatar" :class="{ other: other }">
    <span>{{ userInitials }}</span>
  </div>
</template>

<script>
export default {
  props: {
    other: {
      type: Boolean,
      default: false,
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
  },

  computed: {
    userInitials() {
      return this.firstName.charAt(0).toUpperCase() + this.lastName.charAt(0).toUpperCase();
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar {
  display: flex;
  height: 2.5rem;
  min-height: 2.5rem;
  width: 2.5rem;
  min-width: 2.5rem;
  background-color: $primary-500;
  color: $white;
  border-radius: 100%;
  align-items: center;
  justify-content: center;

  &.other {
    background-color: $secondary-700;
  }

  span {
    font-size: 1rem;
    font-weight: 300;
  }
}
</style>
